import React, { useRef, useState } from "react";

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";

import { useNavigate } from "react-router-dom";

import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";

import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { Button } from "primereact/button";

import { FilterMatchMode } from "primereact/api";

export default function RevenueSummaryReport() {

    const navigate = useNavigate();

    const ds = useRef(null);

    const [rows] = useState(20);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const [globalFilterValue, setGlobalFilterValue] = useState("");

    // REPORT DATA
    const [reportData] = useState([
        {
            month: "April",

            loan_revenue_earned: 100,
            loan_actual_received: 50,
            loan_balance_due: 50,

            project_revenue_commit: 200,
            project_actual_received: 120,
            project_balance_due: 80,

            course_sale: 500,

            software_sale: 1000,
        },

        {
            month: "May",

            loan_revenue_earned: 150,
            loan_actual_received: 80,
            loan_balance_due: 70,

            project_revenue_commit: 300,
            project_actual_received: 220,
            project_balance_due: 80,

            course_sale: 700,

            software_sale: 1200,
        },

        {
            month: "June",

            loan_revenue_earned: 170,
            loan_actual_received: 100,
            loan_balance_due: 70,

            project_revenue_commit: 350,
            project_actual_received: 250,
            project_balance_due: 100,

            course_sale: 800,

            software_sale: 1400,
        },
    ]);

    const onFilter = (event) => {
        setFilters(event.filters);
    };

    const onGlobalFilterChange = (e) => {

        const value = e.target.value;

        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);

        setGlobalFilterValue(value);
    };

    const loadMore = () => {
        console.log("Load More Clicked");
    };

    // HEADER GROUP
    const headerGroup = (
        <ColumnGroup>

            {/* TOP HEADER */}
            <Row>

                <Column
                    header="Revenue Summary"
                    rowSpan={2}
                    style={{
                        backgroundColor: "#92D050",
                        fontWeight: "bold",
                        textAlign: "center",
                    }}
                />

                <Column
                    header="Loan Department"
                    colSpan={3}
                    style={{
                        textAlign: "center",
                        fontWeight: "bold",
                    }}
                />

                <Column
                    header="Project Report Department"
                    colSpan={3}
                    style={{
                        textAlign: "center",
                        fontWeight: "bold",
                    }}
                />

                <Column
                    header="Course Sale"
                    colSpan={1}
                    style={{
                        textAlign: "center",
                        fontWeight: "bold",
                    }}
                />

                <Column
                    header="Software Sale"
                    colSpan={1}
                    style={{
                        textAlign: "center",
                        fontWeight: "bold",
                    }}
                />

            </Row>

            {/* SECOND HEADER */}
            <Row>

                {/* Loan Department */}
                <Column
                    header="Revenue Earned"
                    style={{ backgroundColor: "#92D050" }}
                />

                <Column
                    header="Actual Received"
                    style={{ backgroundColor: "#92D050" }}
                />

                <Column
                    header="Balance Due"
                    style={{ backgroundColor: "#92D050" }}
                />

                {/* Project Report */}
                <Column
                    header="Revenue Earned - Fees Commit"
                    style={{ backgroundColor: "#92D050" }}
                />

                <Column
                    header="Actual Received"
                    style={{ backgroundColor: "#92D050" }}
                />

                <Column
                    header="Balance Due"
                    style={{ backgroundColor: "#92D050" }}
                />

                {/* Course Sale */}
                <Column
                    header="Revenue Earned / Actual Recd"
                    style={{ backgroundColor: "#92D050" }}
                />

                {/* Software Sale */}
                <Column
                    header="Revenue Earned / Actual Recd"
                    style={{ backgroundColor: "#92D050" }}
                />

            </Row>

        </ColumnGroup>
    );

    return (
        <main id="main" className="main">

            <section className="section main-color">

                <div className="row">

                    <div className="col-lg-12">

                        <div className="card-main">

                            <div className="card-body">

                                {/* HEADER */}
                                <h5 className="card-title flex">

                                    <div
                                        className="mr-3 cursor-pointer"
                                        onClick={() => navigate("/masters")}
                                    >
                                        <i className="bi bi-arrow-left-circle-fill"></i>
                                    </div>

                                    Revenue Summary Report

                                </h5>

                                {/* FILTER */}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginTop: 5,
                                        marginBottom: 15,
                                    }}
                                >

                                    <div className="row w-full">

                                        <div className="col-md-4 mb-2">

                                            <InputText
                                                type="text"
                                                value={globalFilterValue}
                                                onChange={onGlobalFilterChange}
                                                placeholder="Keyword Search"
                                                style={{ width: "100%" }}
                                            />

                                        </div>

                                    </div>

                                </div>

                                {/* TABLE */}
                                <div className="card">

                                    <DataTable
                                        value={reportData}
                                        paginator
                                        rows={rows}
                                        filters={filters}
                                        onFilter={onFilter}
                                        globalFilterFields={[
                                            "month",
                                        ]}
                                        stripedRows
                                        responsiveLayout="scroll"
                                        className="p-datatable-gridlines"
                                        headerColumnGroup={headerGroup}
                                        showGridlines
                                    >

                                        {/* MONTH */}
                                        <Column
                                            field="month"
                                            body={(rowData) => (
                                                <b>{rowData.month}</b>
                                            )}
                                            className="product-category table-design-without-btn"
                                        />

                                        {/* LOAN */}
                                        <Column
                                            field="loan_revenue_earned"
                                            className="product-category table-design-without-btn"
                                        />

                                        <Column
                                            field="loan_actual_received"
                                            className="product-category table-design-without-btn"
                                        />

                                        <Column
                                            field="loan_balance_due"
                                            className="product-category table-design-without-btn"
                                        />

                                        {/* PROJECT REPORT */}
                                        <Column
                                            field="project_revenue_commit"
                                            className="product-category table-design-without-btn"
                                        />

                                        <Column
                                            field="project_actual_received"
                                            className="product-category table-design-without-btn"
                                        />

                                        <Column
                                            field="project_balance_due"
                                            className="product-category table-design-without-btn"
                                        />

                                        {/* COURSE SALE */}
                                        <Column
                                            field="course_sale"
                                            className="product-category table-design-without-btn"
                                        />

                                        {/* SOFTWARE SALE */}
                                        <Column
                                            field="software_sale"
                                            className="product-category table-design-without-btn"
                                        />

                                    </DataTable>

                                </div>

                                {/* LOAD MORE */}
                                <div className="flex justify-content-center mt-4">

                                    <Button
                                        type="button"
                                        icon="pi pi-plus"
                                        label="Load More"
                                        onClick={loadMore}
                                    />

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

        </main>
    );
}